import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormField from '../../forms/FormField';
import { Button, Alert } from 'react-bootstrap';

const ContactForm = ({ handleSubmit, submitting, message }) => (
  <form onSubmit={handleSubmit}>

    {message && <Alert bsStyle="danger">{message}</Alert>}

    <Field
      required
      name="firstName"
      type="text"
      component={FormField.Input}
      placeholder="First name"
      validate={[value => value ? undefined : 'Required']}
    />
    <Field
      required
      name="lastName"
      type="text"
      component={FormField.Input}
      placeholder="Last name"
      validate={[value => value ? undefined : 'Required']}
    />
    <Field
      required
      name="email"
      type="email"
      component={FormField.Input}
      placeholder="Email address"
      validate={[value => value ? undefined : 'Required']}
    />
    <Field
      required
      name="phone"
      type="text"
      component={FormField.Input}
      placeholder="Phone"
      validate={[value => value ? undefined : 'Required']}
    />

    <legend>Please select all that apply:</legend>
    <div className="checkboxes">
      <Field
        name="contactType.Winemaker"
        label="Winemaker"
        component={FormField.InlineCheckbox}
      />
      <Field
        name="contactType.Vintner"
        label="Vintner"
        component={FormField.InlineCheckbox}
      />
      <Field
        name="contactType.Grape_Grower"
        label="Grape Grower"
        component={FormField.InlineCheckbox}
      />
      <Field
        name="contactType.Other"
        label="Other"
        component={FormField.InlineCheckbox}
      />
    </div>

    <Button bsStyle="primary" type="submit" disabled={submitting}>
      Lets works together
    </Button>

  </form>
);

export default reduxForm({
  form: 'contact',
  touchOnBlur: false, // call validation only on submit
  validate: values => {
    const errors = {};
    const { contactType } = values;
    if (
      !contactType ||
      Object.keys(contactType).filter(c => contactType[c] === true).length === 0
    ) {
      errors.contactType = { Winemaker: 'Required' };
    }
    return errors;
  }
})(ContactForm);



// WEBPACK FOOTER //
// ./src/components/routes/contactUs/ContactForm.js